<template>
  <DialogTemplateToolkit
    class-name="add-criterion-manually-dialog"
    :dialog="dialog"
    first_btn="Common.Save"
    :title="$t('Common.NewAddress')"
    @apply="createAddress"
    @close="dialog = false">
    <template #activator-btn>
      <sButton
        class="h11-links"
        icon="plus"
        icon-size="10px"
        small
        type="text"
        @click="open">
        {{ $t('Catalog.AddNewAddress') }}
      </sButton>
    </template>
    <template #card-text>
      <div
        class="flex gap-10"
        justify="space-between"
        no-gutters>
        <AddresInputBlock
          :addresses="addresses"
          class="inputs"
          :item.sync="address"
          :mode="mode"/>
        <div class="info-block secondary__green_chosen text-start pa-6 ">
          <div class="h7-text-bold mb-2">
            {{ $t('Tenders.HowDetermineZipCode') }}
          </div>
          <span class="h7-text"> {{ $t('Tenders.UseGuide') }} </span>
          <a
            class="ml-1"
            href="https://index.ukrposhta.ua/find-post-index"
            target="_blank">
            <span class="text-decoration-underline">{{ $t('Tenders.Link') }} </span>
          </a>
        </div>
      </div>
    </template>
  </DialogTemplateToolkit>
</template>

<script>
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'
import AddresInputBlock from 'components/common/blocks/AddresInputBlock.vue'

import SmarttenderApi from '@/api/smarttenderApi'

const api = new SmarttenderApi()
export default {
  name: 'addNewAddress',
  data() {
    return {
      dialog: false,
      address: {
        name: '',
        street_name: '',
        street_type: '',
        index: '',
        flat: '',
        corps: '',
        house: '',
        city: '',
        autocomplete: null
      }
    }
  },
  props: {
    addresses: Array,
    mode: String
  },
  mounted() {
    // this.initAutocomplete()
  },
  methods: {
    createAddress() {
      let clear = () => {
        this.name = ''
        this.city = ''
        this.street_type = ''
        this.street_name = ''
        this.house = ''
        this.flat = ''
        this.corps = ''
        this.index = ''
        this.dialog = false
      }
      if (this.mode == 'tender') {
        api.createSuppliersAddress({
          title: this.address.name,
          cityCode: this.address.city,
          streetType: this.address.street_type,
          street: this.address.street_name,
          house: this.address.house,
          apartment: this.address.flat,
          block: this.address.corps,
          postalCode: this.address.index
        }).then( res => {
          clear()
          // eslint-disable-next-line vue/no-mutating-props
          this.addresses.push(res.data.createSuppliersAddress)
        })
      }
    },
    open() {
      setTimeout(() => this.dialog = true, 100)
    },
  },
  components: {
    DialogTemplateToolkit,
    AddresInputBlock
  }
}
</script>

<style lang="scss" scoped>
.info-block {
  width: 232px;
  border-radius: 8px;
  height: min-content;
}
.inputs {
  max-width: 400px;
  width: 400px;
  min-width: 400px;
  .input {
    max-width: 189px;
    width: 189px;
    min-width: 189px;
  }
}
</style>

<style lang="scss">
.add-criterion-manually-dialog {
  .variants  .input {
    max-width: 150px;
  }
}
</style>
